import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGraduationProcessQueryVariables = Types.Exact<{
  childNo?: Types.InputMaybe<Types.Scalars['String']['input']>;
  memberNo?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetGraduationProcessQuery = { __typename?: 'Query', club_worldFamilyClub_childGraduationApplication?: { __typename?: 'Club_WorldFamilyClub_ChildGraduationApplicationConnection', totalCount: number, nodes?: Array<{ __typename?: 'Club_WorldFamilyClub_ChildGraduationApplication', id: string, applicationCount?: number | null, applicationYear?: number | null, approvedCount?: number | null, childNo?: string | null, graduationDate?: any | null, inReviewCount?: number | null, isExcellent?: boolean | null, lastApprovalDate?: any | null, market?: string | null, memberNo?: string | null, rejectedCount?: number | null }> | null } | null };


export const GetGraduationProcessDocument = gql`
    query getGraduationProcess($childNo: String, $memberNo: String) {
  club_worldFamilyClub_childGraduationApplication(
    filter: {childNo: {eq: $childNo}, memberNo: {eq: $memberNo}}
  ) {
    totalCount
    nodes {
      id
      applicationCount
      applicationYear
      approvedCount
      childNo
      graduationDate
      inReviewCount
      isExcellent
      lastApprovalDate
      market
      memberNo
      rejectedCount
    }
  }
}
    `;

/**
 * __useGetGraduationProcessQuery__
 *
 * To run a query within a React component, call `useGetGraduationProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationProcessQuery({
 *   variables: {
 *      childNo: // value for 'childNo'
 *      memberNo: // value for 'memberNo'
 *   },
 * });
 */
export function useGetGraduationProcessQuery(baseOptions?: Apollo.QueryHookOptions<GetGraduationProcessQuery, GetGraduationProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraduationProcessQuery, GetGraduationProcessQueryVariables>(GetGraduationProcessDocument, options);
      }
export function useGetGraduationProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraduationProcessQuery, GetGraduationProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraduationProcessQuery, GetGraduationProcessQueryVariables>(GetGraduationProcessDocument, options);
        }
export type GetGraduationProcessQueryHookResult = ReturnType<typeof useGetGraduationProcessQuery>;
export type GetGraduationProcessLazyQueryHookResult = ReturnType<typeof useGetGraduationProcessLazyQuery>;
export type GetGraduationProcessQueryResult = Apollo.QueryResult<GetGraduationProcessQuery, GetGraduationProcessQueryVariables>;